module.exports = __webpack_public_path__ + "static/media/transfer-inland-icon.5635d164.svg";